export const ELEVEN_LABS_API_KEY =
    "sk_8ec0078cf35fc7a6b4c2550a853bf8b24bbecf1753c92e7a";
export const ELEVEN_LABS_VOICE_ID = "6vTyAgAT8PncODBcLjRf";
export const DROID_VOICE_ID = "qYnzXO5DpTBrLDDEq6BS";
export const XAVIER_VOICE_ID = "CIji3FFuNHV1i8Jk6rf4";
export const VOICE_SETTINGS = {
    stability: 0.5,
    similarity_boost: 0.75,
};

export enum VOIX {
    ALTIA = "ALTIA",
    C3PO = "C3PO",
    R2D2 = "R2D2",
    XAVIER = "XAVIER",
}

export enum SpeechOptions {
    CORRIGE = "Corrige",
    RALLONGE = "Rallonge",
    RACCOURCIS = "Raccourcis",
    AMICAL = "Amical",
    NEUTRE = "Neutre",
    FORMEL = "Formel",
}
